<template>
  <!-- 
  1.화면ID      : MCF_BT_002
  2.화면명      : 배치 프로시저 등록
  3.작성자      : 김찬종 차장
  4.화면설명    : 배치 프로시저를 등록/수정한다.
  5.Descrition : 2024.04.05 최초작성
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->
    <!-- 타이틀 및 네비게이션 종료 -->
    <!-- 본문내용 시작 -->
    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="프로시저ID" required>
                <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="state.saveType === 'update' ? state.procParams.proc_id : '자동생성'"
                    @update:modelValue="r=>state.procParams.proc_id = r"
                    disabled
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="프로시저명" required>
                <template #end="{id}">
                  <ElInput
                    :id="id"
                    ref="procNmRef"
                    :modelValue="state.procParams.proc_nm"
                    @update:modelValue="r=>state.procParams.proc_nm = r"
                    :disabled="state.saveType === 'update'"
                  />
                </template>
              </ElLabel>

            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="프로시저설명" required>
                <template #end="{id}">
                  <ElInput
                    :id="id"
                    ref="procDescRef"
                    :modelValue="state.procParams.proc_desc"
                    @update:modelValue="r=>state.procParams.proc_desc = r"
                    :disabled="state.saveType === 'update'"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="실행주기 (크론 표현식)" required>
                <template #end="{id}">
                  <ElInput
                    :id="id"
                    ref="cronExpressRef"
                    :modelValue="state.procParams.cron_express"
                    @update:modelValue="r=>state.procParams.cron_express = r"
                    :disabled="state.saveType === 'update'"
                  />
                </template>
              </ElLabel>

            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <div id="" class="form-text text-primary">크론 표현식: 왼쪽부터 [초] [분] [시] [일] [월] [주] 항목으로 해석됩니다.</div>
              <div id="" class="form-text text-primary">특수문자 의미: 
                <span class="fc-red">*</span> (모든 값),
                <span class="fc-red">?</span> (해당없음),
                <span class="fc-red">-</span> (범위),
                <span class="fc-red">,</span> (여러값),
                <span class="fc-red">/</span> (증가치),
                <span class="fc-red">L</span> (마지막 값)</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이전 예약일시">
                <template #end="{id}">
                  <DatePicker 
                    :id="id" 
                    ref="schdDtRef"
                    :frmType="'YMDT'" 
                    format="yyyy-MM-dd hh:mm:ss" 
                    enableTime="true" 
                    :selectDate="state.procParams.prev_dt"
                    @return="r => state.procParams.prev_dt = r"
                    :disabled="state.saveType === 'update'"
                  />
                </template>
              </ElLabel>

            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">

              <ElLabel name="다음 예약일시" required>
                <template #end="{id}">
                  <div class="d-flex">
                    <DatePicker 
                      :id="id" 
                      ref="schdDtRef"
                      :frmType="'YMDT'" 
                      format="yyyy-MM-dd hh:mm:ss" 
                      enableTime="true" 
                      :selectDate="state.procParams.schd_dt"
                      @return="r => state.procParams.schd_dt = r"
                    />
                  </div>
                </template>
              </ElLabel>


            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">

              <ElLabel name="실행순번">
                <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="state.procParams.ord_no"
                    @update:modelValue="r=>state.procParams.ord_no = r"
                  />
                </template>
              </ElLabel>


            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사용여부" required>
                <template #end>
                  <ElSelect ref="useYnRef" v-model="state.procParams.use_yn" :options="state.useYnList"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="save()">저장</ElButton>
        <ElButton type="primary" @buttonClick="$router.push('/cf/MCF_BT_001')">취소</ElButton>
      </div>
    </div>
    <!-- 본문내용 종료 -->
</template>
     
<script setup>   
import {reactive,onBeforeMount,ref} from 'vue';
import DatePicker     from '@/components/common/DatePicker';
import common         from '@/js/common';
import { useRouter } from "vue-router";
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()
const router = useRouter();

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { procCronSelect, procCronEdit } from '@/api/batch';
/** 다음 예약일자 초기화 */
const today = new Date();
const toDate = common.dateFormat(today);
const procNmRef = ref()
const procDescRef = ref()
const cronExpressRef = ref()
const schdDtRef = ref()
const useYnRef = ref()




onBeforeMount(async ()=> {
  let proc_id = history.state.proc_id;
  if(!proc_id) {
    state.saveType = 'insert';
    return;
  }

  state.saveType = 'update';
  try {
    setIsLoading(true)
    const res = await procCronSelect({ proc_id: proc_id })
    let procData = res.rtn;
    for(let p in procData) {
      state.procParams[p] = procData[p];
    }
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
});

//변수 선언 영역 
const state = reactive({
    procParams : {
        proc_id       : '',
        proc_nm       : '',
        proc_desc     : '',
        cron_express  : '',
        prev_dt       : '',
        schd_dt       : '',
        use_yn        : 'Y',
        ord_no        : '',
        exec_begin_dt : '',
        exec_end_dt   : '',
        success_yn    : '',
        error_msg     : ''
    },
    procData : null,
    saveType : 'insert',
    useYnList : [
                {text: '사용', value: 'Y'},
                {text: '미사용', value: 'N'}
              ]
});

/** 저장 */
const save = async () => {
  const isValid = validate();
  if(!isValid) {
    return;
  }

  const isConfirmed = confirm(`저장하시겠습니까?`);
  if(isConfirmed) {
    try {
      setIsLoading(true)
      const res = await procCronEdit(state.procParams)
      alert(`저장되었습니다.\n조회 페이지로 이동합니다.`);
      router.push({name:'MCF_BT_001'})
    } catch (err) {
      alert("에러가 발생하였습니다.");
    } finally {
      setIsLoading(false)
    }
  }
}

/** 입력값 유효성 체크 */
const validate = () => {
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.

  if(state.procParams.proc_nm.trim() == '') {
    alert(msg)
    procNmRef.value.input.focus()
    return false;
  } else if(state.procParams.proc_desc.trim() == '') {
    alert(msg)
    procDescRef.value.input.focus()
    return false;
  } else if(!state.procParams.cron_express.trim()){
    alert(msg)
    cronExpressRef.value.input.focus()
    return false;
  } else if(!state.procParams.schd_dt.trim()){
    alert(msg)
    return false;
  } else if(!state.procParams.use_yn.trim()){
    alert(msg)
    useYnRef.value.input.focus()
    return false;
  }

  return true;
}

</script>
